module.exports = __webpack_public_path__ + "img/Vegetarian Icon - white.1f8b6748.svg";